import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// attach token from localStorage if present
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("asure_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_daily-nutrition-hub-6/artifacts/nfck0bdo_ChatGPT%20Image%20Aug%2015%2C%202026%2C%2011_18_17%20AM.png";

export const HERO_BOX_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_daily-nutrition-hub-6/artifacts/zys1tv6w_ChatGPT%20Image%20Aug%2015%2C%202026%2C%2011_32_16%20AM.png";

export const HERO_BOX_ALT =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_daily-nutrition-hub-6/artifacts/fowu6zi9_ChatGPT%20Image%20Aug%2015%2C%202026%2C%2011_32_07%20AM.png";

export const currency = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);
